export const ADD_EMPLOYEES_DROPDOWN_TEST_IDS = {
  CENSUS_UPLOAD_BUTTON: 'add-employees-dropdown-census-upload-button-test-id',
  SELF_REGISTRATION_BUTTON: 'add-employees-dropdown-self-registration-button-test-id',
  SINGLE_EMPLOYEE_BUTTON: 'add-employees-dropdown-single-employee-button-test-id',
};

export const IMQS_PROGRESS_TAG_TEST_IDS = {
  INFO_BUTTON_FILLED: 'info-button-filled-test-id',
  RADIO_BUTTON_CHECKED: 'radio-button-checked-test-id',
  CHECK_CIRCLE: 'check-circle-test-id',
};
